import * as React from 'react';

import styles from './FatInfrastructureList.css';
import { IFatInfrastructureListItem } from '../../../types';
import { FatInfoBlock } from '../MobileFatInfoBlock';

export interface IFatInfrastructureListProps {
  list: IFatInfrastructureListItem[];
  isHidden: boolean;
}

export function FatInfrastructureList({ list, isHidden }: IFatInfrastructureListProps) {
  if (isHidden || !list.length) {
    return null;
  }

  return (
    <ul className={styles['container']}>
      {list.map(item => (
        <FatInfoBlock key={`${item.title}.${item.imageUrl}`} {...item} />
      ))}
    </ul>
  );
}
